import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

function SrButtonDeprecated({
  className,
  text,
  onClick,
  leftIconClassName,
  rightIconClassName,
  color,
  bgColor,
  borderRadius,
}) {
  return (
    <SrBox
      className={classnames(
        'SrButtonDeprecated',
        className,
      )}
      onClick={onClick}
      bgColor={bgColor}
      borderRadius={borderRadius}
    >
      {leftIconClassName && (
        <span
          className={`left ${leftIconClassName}`}
        />
      )}
      <SrText color={color}>
        {text}
      </SrText>
      {rightIconClassName && (
        <span
          className={`right ${rightIconClassName}`}
        />
      )}
    </SrBox>
  );
}

SrButtonDeprecated.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  leftIconClassName: PropTypes.string,
  rightIconClassName: PropTypes.string,
  color: SrText.propTypes.color,
  bgColor: SrBox.propTypes.bgColor,
  borderRadius: SrBox.propTypes.borderRadius,
};

SrButtonDeprecated.displayName = 'SrButton';

export default SrButtonDeprecated;
